import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

import { PortalProps } from './Portal.props'

export function Portal({ id, children }: PortalProps) {
  const el = useRef(document.createElement('div'))

  useEffect(() => {
    const rootElement = document.getElementById(id) as HTMLElement
    const current = el.current

    rootElement!.appendChild(current)
    return () => void rootElement!.removeChild(current)
  }, [])

  return createPortal(children, el.current)
}
